<template>
 <div class="lake-content">
<table class="ne-table" style="border-collapse: collapse; width: 100%; padding:4px 0; border-color: #d9d9d9; border-style: solid; margin-left: auto; margin-right: auto;" border="1px">
<tbody>
<tr style="height: 24px;">
<td style="border: 1px solid #d9d9d9; width: 148px; text-align: center; vertical-align: middle; height: 24px;" width="148">
<p id="uc8ad3208" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">权限名</span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 24px; text-align: center; vertical-align: middle; width: 21.8365%;" width="195">
<p id="ucec3d8fb" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">权限功能说明</span></p>
</td>
<td style="border: 1px solid #d9d9d9; text-align: center; vertical-align: middle; height: 24px;" width="406">
<p id="u4b6853c2" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">使用场景或目的</span></p>
</td>
</tr>
<tr style="height: 48px;">
<td style="border: 1px solid #d9d9d9; height: 48px; text-align: center; vertical-align: middle; width: 27.971%;" width="148">
<p id="u77682fab" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span style="color: #000000; font-size: 12px;"><span class="ne-text">CAMERA<br /></span></span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 48px; text-align: center; vertical-align: middle; width: 21.8365%;" width="195">
<p id="udf5a16b7" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span style="color: #000000; font-size: 12px;"><span class="ne-text">拍照：</span><span class="ne-text">使用拍摄照片和视频</span></span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 48px; text-align: center; vertical-align: middle; width: 45.4647%;" width="406">
<p id="u861f40c6" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">实现设置、更换头像功能；用于AR学习互动</span></p>
</td>
</tr>
<tr style="height: 88px;">
<td style="border: 1px solid #d9d9d9; height: 88px; text-align: center; vertical-align: middle; width: 27.971%;" width="148">
<p id="u901eaade" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span style="color: #000000; font-size: 12px;"><span class="ne-text">READ_PHONE_STATE<br /></span></span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 88px; text-align: center; vertical-align: middle; width: 21.8365%;" width="195">
<p id="uc6b11d66" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span style="color: #000000; font-size: 12px;"><span class="ne-text">读取手机状态和身份：</span><span class="ne-text">提供读取手机设备标识等信息，请您放心该权限无法监听、获取您的任何通话内容与信息</span></span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 88px; text-align: center; vertical-align: middle; width: 45.4647%;" width="406">
<p id="uc32ceb50" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span style="color: #000000; font-size: 12px;"><span class="ne-text">读取设备通话状态和识别码，识别手机设备</span><span class="ne-text">ID</span><span class="ne-text">，用于信息展示、账号登录、安全保障等主要功能</span></span></p>
</td>
</tr>
<tr style="height: 44px;">
<td style="border: 1px solid #d9d9d9; height: 44px; text-align: center; vertical-align: middle; width: 27.971%;" width="148">
<p id="u6edcd44f" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span style="color: #000000; font-size: 12px;"><span class="ne-text">READ_EXTERNAL_STORAGE<br /></span></span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 44px; text-align: center; vertical-align: middle; width: 21.8365%;" width="195">
<p id="u2474b177" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span style="color: #000000; font-size: 12px;"><span class="ne-text">读取SD卡上的内容：</span><span class="ne-text">提供读取手机储存空间内数据的功能</span></span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 44px; text-align: center; vertical-align: middle; width: 45.4647%;" width="406">
<p id="u49d4e8de" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">实现设置、更换头像功能；在学习过程中要求朗读后，读取您已保存的录音</span></p>
</td>
</tr>
<tr style="height: 44px;">
<td style="border: 1px solid #d9d9d9; height: 44px; text-align: center; vertical-align: middle; width: 27.971%;" width="148">
<p id="u12e4a61d" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span style="color: #000000; font-size: 12px;"><span class="ne-text">WRITE_EXTERNAL_STORAGE<br /></span></span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 44px; text-align: center; vertical-align: middle; width: 21.8365%;" width="195">
<p id="ucd0cc8fa" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span style="color: #000000; font-size: 12px;"><span class="ne-text">修改/删除SD卡中的内容：</span><span class="ne-text">提供写入外部储存功能</span></span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 44px; text-align: center; vertical-align: middle; width: 45.4647%;" width="406">
<p id="u6fca625f" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">用于下载识字课程资料；实现头像上传、上传跟读录音功能</span></p>
</td>
</tr>
<tr style="height: 66px;">
<td style="border: 1px solid #d9d9d9; height: 66px; text-align: center; vertical-align: middle; width: 27.971%;" width="148">
<p id="u3ec4ce4c" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">ACCESS_WIFI_STATE</span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 66px; text-align: center; vertical-align: middle; width: 21.8365%;" width="195">
<p id="u6baeca4f" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">获取 WIFI 状态</span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 66px; text-align: center; vertical-align: middle; width: 45.4647%;" width="406">
<p id="u19d78af7" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">在课程动画加载界面，我们需要访问您的WIFI状态，我们将根据是否连接WiFi，来确定动画、音频等资源加载方式，以优化您的使用体验。</span></p>
</td>
</tr>
<tr style="height: 66px;">
<td style="border: 1px solid #d9d9d9; height: 66px; text-align: center; vertical-align: middle; width: 27.971%;" width="148">
<p id="u982d7382" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">ACCESS_NETWORK_STATE</span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 66px; text-align: center; vertical-align: middle; width: 21.8365%;" width="195">
<p id="uaa7766dc" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">获取网络信息状态</span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 66px; text-align: center; vertical-align: middle; width: 45.4647%;" width="406">
<p id="u8b187d4f" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">在学习过程中，我们需要获取您的网络信息状态，当您的网络波动较大、网络状态差时，会为您弹出请您耐心等待的提示。</span></p>
</td>
</tr>
<tr style="height: 66px;">
<td style="border: 1px solid #d9d9d9; height: 66px; text-align: center; vertical-align: middle; width: 27.971%;" width="148">
<p id="u905e8703" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">RECORD_AUDIO</span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 66px; text-align: center; vertical-align: middle; width: 21.8365%;" width="195">
<p id="uc213eebc" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">录音</span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 66px; text-align: center; vertical-align: middle; width: 45.4647%;" width="406">
<p id="u94a29f12" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">在学习环节中，当您进入到了跟读环节，我们需要访问您的麦克风，以便我们获取您/您孩子的跟读语音。若拒绝，则无法完成跟读环节。</span></p>
</td>
</tr>
<tr style="height: 68px;">
<td style="border: 1px solid #d9d9d9; height: 68px; text-align: center; vertical-align: middle; width: 27.971%;" width="148">
<p id="uab9c0c84" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">READ_PRIVILEGED_PHONE_STATE</span></p>
<p id="u33b2e83d" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;"> </span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 68px; text-align: center; vertical-align: middle; width: 21.8365%;" width="195">
<p id="u3f959059" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">读取手机状态信息</span></p>
<p id="u6a94c7f8" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">（Android 10 ）</span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 68px; text-align: center; vertical-align: middle; width: 45.4647%;" width="406">
<p id="ude82d576" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span style="color: #000000; font-size: 12px;"><span class="ne-text">读取设备通话状态和识别码，识别手机设备</span><span class="ne-text">ID</span><span class="ne-text">，用于信息展示、账号登录、安全保障等主要功能</span></span></p>
</td>
</tr>
<tr style="height: 68px;">
<td style="border: 1px solid #d9d9d9; height: 68px; text-align: center; vertical-align: middle; width: 27.971%;" width="148">
<p id="u374bd709" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">CHANGE_WIFI_STATE</span></p>
<p id="uc63e98db" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 68px; text-align: center; vertical-align: middle; width: 21.8365%;" width="195">
<p id="u059f9710" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">修改 WIFI 状态</span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 68px; text-align: center; vertical-align: middle; width: 45.4647%;" width="406">
<p id="u2af2c772" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">一键登录中时，解决国内机型移动网络权限问题需要</span></p>
</td>
</tr>
<tr style="height: 48px;">
<td style="border: 1px solid #d9d9d9; height: 48px; text-align: center; vertical-align: middle; width: 27.971%;" width="148">
<p id="u65560e3b" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">READ_LOGS</span></p>
<p id="u3dc84dbd" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 48px; text-align: center; vertical-align: middle; width: 21.8365%;" width="195">
<p id="u6a62741a" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">读取系统日志文件</span></p>
</td>
<td style="border: 1px solid #d9d9d9; height: 48px; text-align: center; vertical-align: middle; width: 45.4647%;" width="406">
<p id="u5478053c" class="ne-p" style="margin: 0; padding: 0; min-height: 24px;"><span class="ne-text" style="color: #000000; font-size: 12px;">app 出现错误或异常退出时需要上传日志</span></p>
</td>
</tr>
</tbody>
</table>
</div>
</template>

<script>
export default {
  data() {
    return {
      version: 'x.x.x',
      platform: '-'
    }
  },
  mounted() {
    if (this.$route.query) {
      this.version = this.$route.query.v
      this.platform = this.$router.query.p
    }
  }
}
</script>
